// extracted by mini-css-extract-plugin
module.exports = {"container":"ProgressBar_container__1fR5n","value":"ProgressBar_value__singy","bar":"ProgressBar_bar__1RaSy","progress":"ProgressBar_progress__3wMcV"};